module.exports = __webpack_public_path__ + "img/jeremy.a65a3b2c.jpg";